import { actionUrl } from "@/apiClient";
export const moduleSlug = 'experience';
export const moduleAuth = 'Experience';

export const children = [
  {
    path: "",
    redirect: to => {
      return to.path + '/' + 'feedbacks';
    },
    meta: {
    },
  },
  {
    path : 'feedbacks',
    component: () => import('./pages/FeedbackList.vue'),
    meta: {
      title: 'Experience List',
      linkTitle: 'Feedback',
      linkIcon: 'bar-chart',
      showInNav: true,
      permission: 'Experience.Feedback',
    }
  },
  {
    path: 'summary',
    component: () => import('./pages/FeedbackOverview.vue'),
    meta: {
      title: 'Feedback Summary',
      linkTitle: 'Summary',
      linkIcon: 'eye',
      showInNav: true,
      permission: 'Experience.Summary',
    }
  },
  {
    path: 'nps-analysis',
    component: () => import('./pages/FeedbackReward.vue'),
    meta: {
      title: 'NPS Analysis',
      linkTitle: 'NPS Analysis',
      linkIcon: 'tachometer',
      showInNav: true,
      permission: 'Experience.NpsAnalysis',
    }
  },
 
  {
    path: 'report',
    component: () => import('./pages/FeedbackDetailedReport.vue'),
    meta: {
      title: 'Feedback Report',
      linkTitle: 'Feedback Report',
      linkIcon: 'file-text',
      showInNav: true,
      permission: 'Experience.FeedbackReport',
    }
  },
  {
    path: 'productwise-overview',
    component: () => import('./pages/FeedbackProductWiseOverview.vue'),
    meta: {
      title: 'Feedback Product Wise Overview',
      linkTitle: 'Products',
      linkIcon: 'database',
      showInNav: true,
      permission: 'Experience.Products',
    }
  },
  {
    path: 'Staff',
    component: () => import('./pages/FeedbackStaff.vue'),
    meta: {
      title: 'Feedback Staff',
      linkTitle: 'Staff',
      linkIcon: 'user',
      showInNav: true,
      permission: 'Experience.Staff',
    }
  },
  {
    path: 'config/settings',
    component: () => import('@/components/Configuration/Configurations.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Configurations',
      linkIcon: '',
      showInNav: false,
      brandFlag: 'enableConfigurations',
      permission: 'Experience.Config.Settings',
    }
  },
  {
    path : 'config/sources',
    component: () => import('./pages/FeedbacResponse.vue'),
    props:{ moduleSlug: moduleSlug },
    meta: {
      title: 'Feedback Source',
      linkIcon: '',
      showInNav: false,
      // brandFlag: 'enableConfigurations',
      permission: 'Experience.Config.Sources.Read',
    }
  },
  {
    path: 'config/sources/create',
    component: () => import('./pages/SourceAddOrEdit.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Feedback Add',
      linkIcon: '',
      showInNav: false,
      brandFlag: 'enableConfigurations',
      permission: "Experience.Config.Sources.Write",
    }
  },
  {
    path: 'config/sources/update/:id',
    component: () => import('./pages/SourceAddOrEdit.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Feedback Edit',
      linkIcon: '',
      showInNav: false,
      brandFlag: 'enableConfigurations',
      permission: "Experience.Config.Sources.Write",
    }
  },
  //Feedback Questions 
  {
    path: 'config/questions',
    component: () => import('./pages/FeedbackQuestions/QuestionList.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Feedback Questions List',
      linkIcon: '',
      showInNav: false,
      permission: "Experience.Config.Questions.Read",
    }
  },
  {
    path: 'config/question/create',
    component: () => import('./pages/FeedbackQuestions/QuestionAddOrEdit.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Feedback Question Create',
      linkIcon: '',
      showInNav: false,
      permission: "Experience.Config.Questions.Write",
    }
  },
  {
    path: 'config/question/update/:id',
    component: () => import('./pages/FeedbackQuestions/QuestionAddOrEdit.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Update-Feedback Question ',
      linkIcon: '',
      showInNav: false,
      permission: "Experience.Config.Questions.Write",
    }
  },
  // Feedback Integrations
  {
    path: 'config/integrations',
    component: () => import('./pages/FeedbackIntegrations/OutletIntegrations.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Review Integrations',
      linkIcon: '',
      showInNav: false,
      permission: "Experience.Integrations",
    }
  },
  {
    path: 'config/integrations/google/:id',
    component: () => import('./pages/FeedbackIntegrations/GoogleLinking.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Google Linking',
      linkIcon: '',
      showInNav: false,
      permission: "Experience.Integrations",
    }
  },
];
export const quickLinks = [
  {
    name: 'Settings',
    link: `/${moduleSlug}/config/settings`,
    new: true,
    brandFlag: 'enableConfigurations',
    permission: 'Experience.Config.Settings',
  },
  {
    name: 'Questions',
    link: `/${moduleSlug}/config/questions`,
    new: true,
    permission: 'Experience.Config.Questions',
  },
  {
    name: 'Sources',
    link: `/${moduleSlug}/config/sources`,
    new: true,
    permission: 'Experience.Config.Sources.Read',
  },
  {
    name: 'Integrations',
    link: `/${moduleSlug}/config/integrations`,
    new: true,
    permission: 'Experience.Integrations',
  },
  {
    name: 'Legacy Feedback',
    link: actionUrl + 'merchant/:id/feedback',
    permission: 'Experience.Config.Feedback',
  },
];
